import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserPerformanceAsPeopleLead } from "../../../api/peopleLeadPerformance/getUserGoalAsPl";
import { getUsers } from "../../../api/users/getUsers";
import { useAuthContext } from "../../../hooks";
import EmployeeSc from "./index.sc";

function Index() {
  const [users, Setusers] = useState<any[]>([]);
  const [getMemberPerformance, setGetMemberPerformance] = useState<any[]>([]);
  const auth = useAuthContext();
  const fetchOrguserProjects = async () => {
    await getUserPerformanceAsPeopleLead(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString()
    )
      .then((e) => {
        console.log(e, "hello then");
        setGetMemberPerformance(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrguserProjects();
  }, []);
  const navigate = useNavigate();

  return (
    <EmployeeSc>
      <div className="employee_header">Insytix Employees</div>
      <div className="employee_directory_x_container">
        <div className="employee-container">
          {getMemberPerformance.length > 0 ? (
            getMemberPerformance?.map((data) => {
              return (
                <>
                  <div className="employee-list-containers-mag">
                    <div className="profile-list-mag">
                      <div className="employee-image mx-2 w-25"></div>
                      <div className="employee-name mx-2 w-75">{data.Name}</div>
                    </div>
                    <div className="employee-list">{data.Evaluation}</div>
                    <div className="performance-status">
                      <div
                        className="project-lead-approval-status"
                        onClick={() => navigate(`${data?.org_user_id}`)}
                      >
                        View Details
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <div className="alert-messages">
              Only people lead can access this page
            </div>
          )}
        </div>
      </div>
    </EmployeeSc>
  );
}

export default Index;
